import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { useAuth } from "../../context/AuthContext";
import { KYC_REQUESTED as T } from "../../config/zinihubConfig";
import styles from "./KYCRequested.module.css";

const KYCRequested = () => {
  const { token, decodeToken } = useAuth();
  const navigate = useNavigate();
  const decodedToken = useMemo(() => decodeToken(token), [token, decodeToken]);

  if (!decodedToken) {
    return (
      <div className={styles.loadingWrap}>
        <Spin size="large" />
        <p className={styles.loadingText}>Loading...</p>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.topRow}>
        <div className={styles.pageTitle}>{T.PAGE_TITLE}</div>
        <div className={styles.navBtns}>
          <div className={styles.navBtn} onClick={() => navigate("/hubSettings/kyc/verified")}>{"\u2705"} Show Verified</div>
          <div className={styles.navBtn} onClick={() => navigate("/hubSettings/kyc/rejected")}>{"\u274c"} Show Rejected</div>
        </div>
      </div>

      <div className={styles.statusCard}>
        <div className={styles.statusHeader}>
          <div className={styles.statusIconWrap}>
            <span>{T.STATUS_ICON}</span>
          </div>
          <div className={styles.statusInfo}>
            <div className={styles.statusTitle}>{T.STATUS_TITLE}</div>
            <div className={styles.statusDate}>{T.SUBMITTED_ON}</div>
          </div>
          <span className={styles.statusBadge}>{T.BADGE}</span>
        </div>
        <div className={styles.statusInfoBox}>{T.INFO_TEXT}</div>
        <div className={styles.statusFootnote}>{T.FOOTNOTE}</div>
      </div>

      <div className={styles.docsCard}>
        <div className={styles.docsTitle}>{T.DOCS_TITLE}</div>
        {T.DOCS.map(({ icon, title, sub }) => (
          <div key={title} className={styles.docRow}>
            <span className={styles.docIcon}>{icon}</span>
            <div className={styles.docContent}>
              <div className={styles.docTitle}>{title}</div>
              <div className={styles.docSub}>{sub}</div>
            </div>
            <span className={styles.docStatus}>{T.UPLOADED_LABEL}</span>
          </div>
        ))}
      </div>

      <div className={styles.whatsappBanner}>
        {"\ud83d\udcac"} {T.WHATSAPP_BANNER}
      </div>
    </div>
  );
};

export default KYCRequested;
